import { formatCurrency } from '../utils';

export default function KeyValueList({
  title,
  value,
  isCurrency = true,
}: {
  title: string;
  value: string | number;
  isCurrency?: boolean;
}) {
  return (
    <>
      {Number(value) > 0 && (
        <div
          className="h-full w-full relative 
                        flex justify-between gap-[10px]
                        px-[10px] py-[10px]"
        >
          <div
            className="font-dmsans 
            text-[12px]
            text-gray-700"
          >
            {title}:
          </div>
          <div
            className="font-dmsans font-bold 
            text-primary-600 text-[12px]"
          >
            {isCurrency ? formatCurrency(Number(value)) : value}
          </div>
        </div>
      )}
    </>
  );
}
